import './Incognito.sass';

import React, { FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  BottomBar,
  Button,
  Form,
  FormItem,
  Header,
  List,
  ListItem,
  Switch,
} from '$uikit';

import { useTranslator } from '$hooks';
import { mainActions, mainSelector } from '$store/main';
import { goTo } from '$navigation/helper';
import { OTHER } from '$shared/constants/pages';

export const Incognito: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const { mVerified, incognito } = useSelector(mainSelector);

  useEffect(() => {
    if (!mVerified) {
      goTo(OTHER);
    }
  }, [mVerified]);

  const handleEnabled = useCallback(() => {
    dispatch(mainActions.setIncognitoEnabled(!incognito));
  }, [incognito]);

  const handleSend = useCallback(() => {
    dispatch(mainActions.editIncognitoEnabled(incognito));
  }, [incognito]);

  return (
    <>
      <Header showBackButton>{t('incognito_title')}</Header>
      <Form>
        <FormItem description={t(`incognito_description`)}>
          <List>
            <ListItem
              onClick={handleEnabled}
              after={<Switch checked={incognito} />}
              disableHighlight
            >
              {t(`incognito_enabled`)}
            </ListItem>
          </List>
        </FormItem>
      </Form>
      <BottomBar>
        <Button onClick={handleSend} stretched>
          {t('save')}
        </Button>
      </BottomBar>
    </>
  );
};
